import * as React from "react"
import styled from "styled-components"


const Container = styled.div`
  margin: 3rem auto;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

const IndexPage = () => {
  return (
    <main>
      <title>Bumanto</title>
      <Container>
        <h1>Bumanto</h1>
        <h2>Yea, Victoria</h2>
      </Container>
    </main>
  )
}

export default IndexPage
